import _ from "lodash"
import { diff } from '../lib/render-object'
import { ChangeProps } from './change-renderer'

// NB meant for general cases, but some specific mappings exist here when they are the only thing that would be in a custom controls
const mapper = (text) => {
  return {
    accountnumber: 'Account Number',
    areametric: 'Area Metric',
    organizationdetail: 'Organization Settings',
    propertytype: 'Property Type',
    recoverydetail: 'Recovery',
    sortorder: 'Sort Order',
    summaryaccount: 'Summary Account'
  }[text] || _.startCase(text)
}

const resource_m = (text) => {
  return {
    // it's bogus to be mapping these accounts in the "default" change render
    detailaccount: 'Detail Account',
    summaryaccount: 'Summary Account'
  }[text] || _.startCase(text)
}

type DefaultChange = {
  new: object
  old: object
}

const alwaysDrop = ['externalreference', 'organizationid']

export const diffif = (props: ChangeProps) =>
  () => {
    const change = JSON.parse(props.change) as DefaultChange
    const diffs = diff(change.old, change.new, mapper, null, alwaysDrop)
    const changedkeys = _(diffs).filter(x => x.indent == 1).map('key').uniq().map(s => s.replace(/detail$/, '')).tap(xs => xs.length < 5 ? xs : _.take(5).concat('...')).join(', ')
    return {
      atRest: 
        props.method == 'POST' ? `Created ${resource_m(props.resource)}` : 
        props.method == 'DELETE' ? `Deleted ${resource_m(props.resource)}` :
        props.user.service == 'reorder' ? `Reordered ${resource_m(props.resource)}` :
        changedkeys,
      diffs: diff(change.old, change.new, mapper, null, alwaysDrop),
      ...props
    }
  }
